import Dentity from "./dentity.js";
export default Dentity;
